// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  height: 400px;
  padding: 0% 10%;
}
.col-1 {
  background-color: antiquewhite;
  height: 100%;
}

.col-3 {
  background-color: #005eb8;
  height: 103%;
}

.col-2 {
  padding-top: 40px;
  
}

.choose-api {
  padding-left: 5%;
  padding-top: 10%;
}

.choose-api li {
  list-style: none;
  padding: 5px 0;
  cursor: pointer;
  color: #666666;
  font-size: 18px;
  font-weight: 500;
  &:focus-visible {
    outline: 2px solid #0079c2;
    outline-offset: 2px;
    border-radius: 2px;
  }
}

.choose-api > span {
  font-weight: 500;
  font-size: 20px;
  text-transform: uppercase;
  padding: 10px 0;
}

.partnerTypeAPIList {
  padding: 6px;
  font-family: Lato;
  font-size: 18px;
  font-weight: 400;
  line-height: 22px;
  text-align: left;
  color: #666666;
  cursor: pointer;
  text-decoration: none;
  &:focus-visible {
    outline: 2px solid #0079c2;
    outline-offset: 2px;
    border-radius: 2px;
  }
}

.partnerTypeAPIList:hover,
.partnerTypeAPIList:focus {
  color: #286CE2;
  text-decoration: none;
}

.apiServiceHeading {
  color: #666666;
  margin-left: 45px;
  font-family: Lato;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.5px;
  text-align: left;
}

.apiServiceBody {
  margin-top: 18px;
  font-variant-ligatures:none;
}

ul {
  list-style-type: none;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}

.newReleaseHeading {
  color: #fff;
  font-size: 16px;
  margin-left: 37px;
}

.newReleaseSection {
  padding: 15px 2px;
  width: 21.5rem;
  position: absolute;
}

.brokerNewsHeading {
  color: #fff;
  font-size: 27px;
  margin-left: 37px;
  font-family: Congress Serial;
}

.brokerNewsHeadTitle {
  font-family: Bitter;
  font-size: 2rem;
  font-weight: 600;
  line-height: 2.4rem;
  text-align: left;
}

.brokerNewsText {
  color: #fff;
  font-family: Lato;
  font-size: 16px;
  font-weight: 500;
  line-height: 19.2px;
  text-align: left;

}

.ant-avatar {
  background-color: #fff;
}

.chooseAPIBox {
  padding-top: 25px;
  font-variant-ligatures:none;
}
.choose-api-by-partner {
  font-family: Lato;
font-size: 24px;
font-weight: 600;
line-height: 36px;
text-align: left;
color: #333333;


}
`, "",{"version":3,"sources":["webpack://./client/components/Header/APIListCss.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kCAAkC;EAClC,aAAa;EACb,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,iBAAiB;;AAEnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB;IACE,0BAA0B;IAC1B,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB;IACE,0BAA0B;IAC1B,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA;;EAEE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;;AAElB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;AACA;EACE,iBAAiB;AACnB,eAAe;AACf,gBAAgB;AAChB,iBAAiB;AACjB,gBAAgB;AAChB,cAAc;;;AAGd","sourcesContent":[".App {\n  display: grid;\n  grid-template-columns: 1fr 2fr 1fr;\n  height: 400px;\n  padding: 0% 10%;\n}\n.col-1 {\n  background-color: antiquewhite;\n  height: 100%;\n}\n\n.col-3 {\n  background-color: #005eb8;\n  height: 103%;\n}\n\n.col-2 {\n  padding-top: 40px;\n  \n}\n\n.choose-api {\n  padding-left: 5%;\n  padding-top: 10%;\n}\n\n.choose-api li {\n  list-style: none;\n  padding: 5px 0;\n  cursor: pointer;\n  color: #666666;\n  font-size: 18px;\n  font-weight: 500;\n  &:focus-visible {\n    outline: 2px solid #0079c2;\n    outline-offset: 2px;\n    border-radius: 2px;\n  }\n}\n\n.choose-api > span {\n  font-weight: 500;\n  font-size: 20px;\n  text-transform: uppercase;\n  padding: 10px 0;\n}\n\n.partnerTypeAPIList {\n  padding: 6px;\n  font-family: Lato;\n  font-size: 18px;\n  font-weight: 400;\n  line-height: 22px;\n  text-align: left;\n  color: #666666;\n  cursor: pointer;\n  text-decoration: none;\n  &:focus-visible {\n    outline: 2px solid #0079c2;\n    outline-offset: 2px;\n    border-radius: 2px;\n  }\n}\n\n.partnerTypeAPIList:hover,\n.partnerTypeAPIList:focus {\n  color: #286CE2;\n  text-decoration: none;\n}\n\n.apiServiceHeading {\n  color: #666666;\n  margin-left: 45px;\n  font-family: Lato;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n  letter-spacing: 0.5px;\n  text-align: left;\n}\n\n.apiServiceBody {\n  margin-top: 18px;\n  font-variant-ligatures:none;\n}\n\nul {\n  list-style-type: none;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n}\n\n.newReleaseHeading {\n  color: #fff;\n  font-size: 16px;\n  margin-left: 37px;\n}\n\n.newReleaseSection {\n  padding: 15px 2px;\n  width: 21.5rem;\n  position: absolute;\n}\n\n.brokerNewsHeading {\n  color: #fff;\n  font-size: 27px;\n  margin-left: 37px;\n  font-family: Congress Serial;\n}\n\n.brokerNewsHeadTitle {\n  font-family: Bitter;\n  font-size: 2rem;\n  font-weight: 600;\n  line-height: 2.4rem;\n  text-align: left;\n}\n\n.brokerNewsText {\n  color: #fff;\n  font-family: Lato;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 19.2px;\n  text-align: left;\n\n}\n\n.ant-avatar {\n  background-color: #fff;\n}\n\n.chooseAPIBox {\n  padding-top: 25px;\n  font-variant-ligatures:none;\n}\n.choose-api-by-partner {\n  font-family: Lato;\nfont-size: 24px;\nfont-weight: 600;\nline-height: 36px;\ntext-align: left;\ncolor: #333333;\n\n\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
